<template>
    <UserAccountLayout>
            <div class="user-account__fields">
                <div class="input-wrapper">
                    <span class="input-wrapper__title">{{ trans("Name") }}, {{ trans('surname') }}</span>
                    <input v-model="this.$store.state.settings.user.name" type="text" placeholder="John Wick"
                           name="full_name" class="input-element input-wrapper__element-inp">
                </div>
                <div class="input-wrapper">
                    <div class="user-account__email-title-line">
                        <span class="input-wrapper__title">(e-mail)</span>

                    </div>
                    <input v-model="this.$store.state.settings.user.email" type="text" placeholder="john.wick@gmail.com"
                           name="email" class="input-element input-wrapper__element-inp">
                </div>
                <div class="input-wrapper">
                    <span class="input-wrapper__title">{{ trans('Mobile phone') }}</span>
                    <input v-model="this.$store.state.settings.user.phone" type="text" placeholder="+7 (999) 999-99-99"
                           name="phone"
                           class="input-element input-wrapper__element-inp">
                </div>
                <div class="input-wrapper">
                    <p class="input-wrapper__title"> {{ trans("Gender") }}</p>
                    <div class="select-size">
                        <div class="select-size__header input-wrapper__element-inp" @click="show_gender = !show_gender"
                             :class="show_gender ? 'select-active':''">
                            <p class="select-size__header-title sex-select__title"
                               v-if="this.$store.state.settings.user.gender_id">
                                {{ this.$store.state.settings.user.gender_id == 1 ? trans('male') : trans('female') }}</p>
                            <p class="select-size__header-title sex-select__title"
                               v-if="!this.$store.state.settings.user.gender_id">{{ trans("Not selected") }}</p>
                            <img class="select-size__header-img" src="https://batnorton.com/img/svg/select-ar.svg"
                                 alt="">
                        </div>
                        <div class="select-size__body">
                            <ul class="list select-size__list" v-show="show_gender"
                                :class="show_gender ? 'select-size__body_displayed':''">
                                <li @click="setGender(1)" class="list__element select-size__element">
                                    <span class="select-size__element-value">{{ trans('male') }}</span>
                                    <span class="select-size__element-value"></span>
                                </li>
                                <li @click="setGender(2)" class="list__element select-size__element">
                                    <span class="select-size__element-value">{{ trans('female') }}</span>
                                    <span class="select-size__element-value"></span>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
                <div class="input-wrapper">
                    <span class="input-wrapper__title">{{ trans("New password") }}</span>
                    <input v-model="new_password"
                           id="new_password"
                           autocomplete="new-password"
                           type="password"
                           placeholder=""
                           name="new_password"
                           class="input-element input-wrapper__element-inp">

                </div>
                <div class="input-wrapper" v-show="show_new_password">
                    <span class="input-wrapper__title">{{ trans("Confirm the password") }}</span>
                    <input v-model="new_password_confirmation"
                           type="password"
                           placeholder=""
                           autocomplete="new-password"
                           name="new_password_confirmation"
                           class="input-element input-wrapper__element-inp">

                </div>
                <div class="user-account__save-block new_password-js">


                    <button @click.prevent="UpdatePassword" class="btn btnV2 user-account__save-btn">
                        {{ trans("Save") }}
                    </button>
                </div>
            </div>
            <div class="user-account__feed-row">
                <p class="user-account__big-text-line">{{ trans("Subscribe to the newsletter") }}</p>
                <button @click="setSubscription" class="btn btnV2" id="unsubscribe-js">
                    {{ this.$store.state.settings.user.subscription ? trans("Unsubscribe") : trans("Subscribe") }}
                </button>

            </div>
    </UserAccountLayout>
</template>

<script>
import UserAccountLayout from './user-account-layout.vue'

export default {
    name: "personal",
    components: {
        UserAccountLayout,
    },
    mounted() {
        this.checkGuestId()
    },
    data() {
        return {
            new_password_confirmation: '',
            new_password: '',
            show_gender: false,
            show_new_password: false,
            error_message: false,
        }
    },
    watch: {
        new_password() {
            if (this.new_password.length > 0) {
                this.show_new_password = true
            } else {
                this.show_new_password = false
            }
        }
    },
    methods: {
        passwordValidate() {
            this.error_message = false
            if (this.new_password !== '') {
                if (this.new_password.length < 6) {
                    this.$notify({
                        title: this.trans('Error'),
                        text: this.trans("The password is at least 6 characters long"),
                        type: 'error',
                    });
                    this.error_message = true
                }
                if (this.new_password !== this.new_password_confirmation) {
                    this.$notify({
                        title: this.trans('Error'),
                        text: this.trans("The password does not match"),
                        type: 'error',
                    });
                    this.error_message = true
                }
                if (this.error_message) {
                    return false
                }
            }
            return true;
        },
        async UpdatePassword() {
            if (this.passwordValidate()) {
                await axios.post('/api/v1/update-password',
                    this.setParam({
                        password: this.new_password,
                        user: this.$store.state.settings.user
                    })
                )
                    .then(data => {
                        if(data.data.status === 'success'){
                            this.show_new_password = ''
                        }
                        if(data.data.user ){
                            this.$store.state.settings.user = data.data.user
                            this.updateStorage('settings', this.$store.state.settings)
                        }
                        this.$notify({
                            title: data.data.title,
                            text: data.data.text,
                            type: data.data.status,
                        });
                    })
            }
        },

        setSubscription() {
            this.$store.state.settings.user.subscription = !this.$store.state.settings.user.subscription
            this.UpdatePassword()
        },
        setGender(male) {
            this.$store.state.settings.user.gender_id = male
            this.updateStorage(this.$store.state.settings)
            this.show_gender = false
        },
        checkGuestId() {
            const settingsJson = localStorage.getItem('settings')
            if (settingsJson !== null) {
                const settings = JSON.parse(settingsJson)
                if (settings?.guest?.id && this.$store.state.settings?.guest?.id) {
                    if (this.$store.state.settings.guest.id !== settings.guest.id) {
                        this.updateStorage(this.$store.state.settings)
                    }
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
